import css from "styled-jsx/css";
import { ALWAYS_ON_TOP } from "constants/z-index";
import Constants from "constants/main-signup-popup";

const popUpMarginTop = Constants.MAIN_POPUP_HEIGHT / 2;
const popUpMarginLeft = Constants.MAIN_POPUP_WIDTH / 2;

export const componentStyles = css.global`
  .signup-popup-modal {
    position: fixed;
    top: calc(50% - ${popUpMarginTop}px);
    left: calc(50% - ${popUpMarginLeft}px);

    .signup-popup-screen {
      filter: drop-shadow(0px 8px 12px rgba(29, 140, 242, 0.16));
      width: 100%;
      height: 100%;
      .signup-popup-content {
        .signup-popup-title {
          font-size: 28px;
        }
        .popup-email-signup-wrapper {
          .signup-form-core-component-wrapper {
            .signup-input {
              max-width: 400px;
            }
          }
        }
      }
    }
  }

  .signup-popup-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${ALWAYS_ON_TOP};
    backdrop-filter: blur(4px);
    background-color: rgba(0, 0, 0, 0.3);
  }
`;
